import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
const useScrollToTop = () => {
  const $ = _c(4);
  const {
    pathname,
    state
  } = useLocation();
  let t0;
  if ($[0] !== state) {
    t0 = () => {
      if (!state || state.scroll !== false) {
        window.scrollTo(0, 0);
      }
    };
    $[0] = state;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname) {
    t1 = [pathname];
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
};
export default useScrollToTop;